import * as yup from 'yup'

import ErrorMessages from '$/types/enums/ErrorMessages'
import TestTypes from '$/types/enums/TestTypes'

import questionAnswerValueTest from '../tests/questionAnswerValueTest'
import questionAnswerSchema from './questionAnswerSchema'

const autocompleteSchema = yup
  .array()
  .of(yup.object(questionAnswerSchema))
  .test(
    TestTypes.IS_QUESTION_ANSWER_ARRAY,
    ErrorMessages.NO_VALUE_ENTERED,
    questionAnswerValueTest,
  )

export default autocompleteSchema
